/**
 * Which state a data-driven view must render, derived from the queries it depends on.
 *
 * Exists because "no data yet" and "the request failed" are indistinguishable once a view
 * reaches for a `?? 0` fallback. The overview did exactly that and told a paying customer
 * with a connected HubSpot and 400 captures "Kein CRM verbunden · Erfassungen heute 0" —
 * confident, precise, and wrong — whenever the API was unreachable. A fresh deployment
 * missing one env var answers `503 missing_config` to every call and produces that page.
 *
 * A failure outranks a pending load: once ANY query has failed the page can no longer be
 * trusted as a whole, and showing a spinner for the rest would only delay the truth.
 */

export interface QueryLike {
  isLoading: boolean;
  error: unknown;
}

export type ViewState =
  | { kind: "loading" }
  | { kind: "error"; error: unknown }
  | { kind: "ready" };

export function resolveViewState(queries: readonly QueryLike[]): ViewState {
  const failed = queries.find((q) => q.error != null);
  if (failed) return { kind: "error", error: failed.error };
  if (queries.some((q) => q.isLoading)) return { kind: "loading" };
  return { kind: "ready" };
}
